module.exports = __webpack_public_path__ + "static/media/UN-08.38b60ed8.jpg";